<div class="generic-modal-root" >

    <div class="row-padding">
      <div class="row" style="margin-top: 0;" [formGroup]="form">
          <h3 style="text-align: center; font-weight: 300;">Verify Winner</h3>

          <input
            *ngIf="collectName"
            formControlName="first"
            style="width: 100%; margin-bottom: 15px;"
            id="first"
            type="text"
            [ignoreWhiteSpace]
            class="form-control m-input"
            placeholder="First"
          />
          <app-validation-display
            [control]="form.controls.first"
            errorMessage="This field is required.">
          </app-validation-display>

          <input
            *ngIf="collectName"
            formControlName="last"
            style="width: 100%; margin-bottom: 15px;"
            id="last"
            type="text"
            [ignoreWhiteSpace]
            class="form-control m-input"
            placeholder="Last"
          />
          <app-validation-display
            [control]="form.controls.last"
            errorMessage="This field is required.">
          </app-validation-display>
      </div>
    </div>
    <span style="display: block;" *ngIf="!collectName">The name has already been collected.</span>
  
    <div style="height: 45px;">
      <button (click)="close()" class="btn btn-danger" style="margin-left: 15px;float: right;margin-top: 10px;">Cancel</button>
      <button (click)="verify()" class="btn btn-success" style="margin-left: 15px;float: right;margin-top: 10px;">Verify</button>
    </div>
  </div> 